class CartNotification extends HTMLElement {
  constructor() {
    super();
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    });

    // Update cart counter
    this.updateCartCounter(parsedState);

    if (this.header) this.header.reveal();
    this.open();
  }

  updateCartCounter(parsedState) {
    const cartCount = parsedState.item_count || 0;
    
    // Update desktop cart counter
    const cartBubble = document.getElementById('cart-count-bubble');
    if (cartBubble) {
      cartBubble.textContent = cartCount;
      if (cartCount > 0) {
        cartBubble.classList.remove('hidden');
      } else {
        cartBubble.classList.add('hidden');
      }
    }

    // Update mobile cart counter
    const mobileCartCount = document.getElementById('mobile-cart-count');
    if (mobileCartCount) {
      mobileCartCount.textContent = cartCount;
    }

    // Update notification counter
    const notificationCount = document.getElementById('cart-notification-count');
    if (notificationCount) {
      notificationCount.textContent = cartCount;
    }

    // Add animation effect
    if (cartBubble && cartCount > 0) {
      cartBubble.style.transform = 'scale(1.3)';
      setTimeout(() => {
        cartBubble.style.transform = 'scale(1)';
      }, 150);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: '.cart-notification-product',
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
        selector: '.cart-notification__links',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  open() {
    this.classList.add('animate', 'active');
    
    // Start progress bar animation
    const progressBar = document.getElementById('notification-progress');
    if (progressBar) {
      setTimeout(() => {
        progressBar.style.width = '100%';
        progressBar.style.animation = 'progressBar 5s linear forwards';
      }, 100);
    }
    
    // Auto close after 5 seconds
    this.activeTimer = setTimeout(() => {
      this.close();
    }, 5000);

    this.addEventListener('keyup', this.onKeyUp);
    this.addEventListener('click', this.onNotificationClick.bind(this));
    document.body.addEventListener('click', this.onBodyClick);
  }

  onNotificationClick(event) {
    // Allow links to navigate normally
    const linkElement = event.target.closest('a');
    const buttonElement = event.target.closest('button');
    
    if (linkElement) {
      // If it's a continue shopping link, close the notification
      if (linkElement.href && linkElement.href.includes('collections')) {
        setTimeout(() => this.close(), 50);
      }
      // Allow navigation to proceed
      return true;
    }
    
    if (buttonElement) {
      event.stopPropagation();
    }
  }

  close() {
    this.classList.remove('active');
    clearTimeout(this.activeTimer);
    
    // Reset progress bar
    const progressBar = document.getElementById('notification-progress');
    if (progressBar) {
      progressBar.style.width = '0%';
      progressBar.style.animation = 'none';
    }
    
    this.removeEventListener('keyup', this.onKeyUp);
    this.removeEventListener('click', this.onNotificationClick.bind(this));
    document.body.removeEventListener('click', this.onBodyClick);
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.close();
  }

  onBodyClick(event) {
    if (event.target !== this && !event.target.closest('cart-notification')) {
      this.close();
    }
  }
}

customElements.define('cart-notification', CartNotification);